import React from 'react';
import { connect } from '../../../../redux/store';
import {
  DefaultHeaderComponent,
  DefaultBodyComponent,
  standardConnectMapper,
  DefaultToggleButton,
} from '../ActivityNode';
import { Card } from '@kineticdata/bundle-common';
import classNames from 'classnames';

export const DefaultNode = connect((state, props) => ({
  ...standardConnectMapper({
    state,
    props,
    dataListExcludes: [
      'Status',
      'Link',
      'InternalLink',
      'DownloadInternalLink',
      'Reference Id',
    ],
  }),
}))(
  ({
    className,
    activity,
    data,
    dataList,
    hasDataList,
    link,
    isDownload,
    approval,
    action,
    appLocation,
    location,
    isOpen,
    toggle,
    isMobile,
  }) => {
    const hasBody = dataList.length > 0 || approval || action;
    return (
      <li className={classNames('activity__row', className)}>
        <div className="card-wrapper">
          <DefaultToggleButton
            isOpen={!hasBody || isOpen}
            toggle={hasBody ? toggle : undefined}
          />
          <Card>
            <DefaultHeaderComponent
              status={data.Status}
              title={activity.label}
              link={link}
              isDownload={isDownload}
              meta={[
                { label: 'Created', value: activity.createdAt, timeAgo: true },
                activity.createdAt !== activity.updatedAt && {
                  label: 'Updated',
                  value: activity.updatedAt,
                  timeAgo: true,
                },
              ].filter(Boolean)}
              isOpen={!hasBody || isOpen}
              toggle={hasBody ? toggle : undefined}
              isMobile={isMobile}
            />
            {hasBody && (
              <DefaultBodyComponent
                dataList={dataList}
                approval={approval}
                action={action}
                isOpen={isOpen}
                toggle={toggle}
                appLocation={appLocation}
                location={location}
              />
            )}
          </Card>
        </div>
      </li>
    );
  },
);
